import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Stats from "@/components/Stats";
import Programs from "@/components/Programs";
import Events from "@/components/Events";
import Gallery from "@/components/Gallery";
import MediaWall from "@/components/MediaWall";
import Donate from "@/components/Donate";
import JoinForm from "@/components/JoinForm";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <div data-testid="home-page" className="bg-cream">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Stats />
        <Programs />
        <Events />
        <Gallery />
        <MediaWall />
        <Donate />
        <JoinForm />
      </main>
      <Footer />
    </div>
  );
}
